import { CardBody, InputGroup, InputGroupAddon } from "reactstrap";
import "../../../../assets/css/alljob.css";
import React, { useState, useEffect } from "react";
import { Row, Card, Col, Input, Button } from "reactstrap";
import { isNullOrEmpty } from "../../../../config/ENV";
import orgImage from "../../../../../src/assets/img/images/office.jpeg";
import { getAllJobsSearch } from "../../../../services/AllJobsService";
import AllJobsDescription from "./AllJobsDescription";
import { showSalary } from "../../../../utilities/showsalary";
import {dayDifference} from "../../../../utilities/daysutility";
import {
  getAllEnumLists,
  getEnumLists,
} from "../../../../services/MetadataService";
import { Colxx } from "../../../../components/common/CustomBootstrap";
import { FormGroup } from "react-bootstrap";
import TeamanicsButtonStyle from "../../../../buttoncomponent/TeamanicsButton";
import SearchPlaceComponent from "../../../candidateinfo/searchPlaceComponent";
const AllJobs = () => {
  const [responseList, setResponseList] = useState([]);
  const [size, setSize] = useState("");
  const [search, setSearch] = useState("");
  const [findJobs, setFindJobs] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [totalPage, setTotalPage] = useState(1);
  const [salaryType, setSalaryType] = useState([]);
  const [selectedSalaryType, setSelectedSalaryType] = useState("hourly");
  const [jobSalaryType, setJobSalaryType] = useState("");
  const [jobType, setJobType] = useState([]);
  const [selectedJobType, setSelectedJobType] = useState("");
  const [JobsType, setJobstype] = useState("");
  const [workStatus, setWorkStatus] = useState([]);
  const [selectedWorkStatus, setSelectedWorkStatus] = useState("");
  const [jobWorkStatus, setJobWorkStatus] = useState("");
  const [salaryMin,setSalaryMin]=useState();
  const [distance, setDistance] = useState("");
  const [ModalLong,setModalLong]=useState(false)
  const [postedOn,setPostedOn]=useState()
  const[selectedId,setSelectedId]=useState("")

const[sortOrder,setSortOrder]=useState("asc")
  const [address, setAddress] = useState({
    city: "",
    state: "",
    zipcode: "",
    latitude: "",
    longitude: "",
  });

  const handleCallback = (googlePlaces) => {
    setAddress((prevState) => ({
      ...prevState,
      city: googlePlaces.city,
      state: googlePlaces.state,
      zipcode: googlePlaces.zipcode,
      latitude: googlePlaces.latitude,
      longitude: googlePlaces.longitude,
    }));
  };

  useEffect(() => {
    getAlljobsList();
    getJobEnum();
   
   
   
  }, [itemsPerPage]);
  const getAlljobsList = () => {
    // let city = "";
    // if (address.city) {
    //   city = address.city;
    // }

    // let state = "";
    // if (!isNullOrEmpty(address.state)) {
    //   state = address.state;
    // }
    // let zipcode = "";
    // if (!isNullOrEmpty(address.zipcode)) {
    //   zipcode = address.zipcode;
    // }
    let latitude = "";
    if (address.latitude) {
      latitude = address.latitude;
    }

    let longitude = "";
    if (!isNullOrEmpty(address.longitude)) {
      longitude = address.longitude;
    }
    var salaryType = "";
    if (!isNullOrEmpty(jobSalaryType)) {
      salaryType = jobSalaryType;
    }
    var jobType = "";
    if (!isNullOrEmpty(JobsType)) {
      jobType = JobsType;
    }
    var workStatus = "";
    if (!isNullOrEmpty(jobWorkStatus)) {
      workStatus = jobWorkStatus;
    }
    getAllJobsSearch(
      search,
      latitude,
      longitude,
      distance,
      salaryMin,
      salaryType,
      jobType,
      postedOn,
      workStatus,
      100,
      sortOrder,
    ).then((response) => {
    

      let size = response.data.size;
      setSize(size);
      try {
        if (response.data !== null) {
          var jobs = response.data.jobs 
          setResponseList(jobs);

          let jobId='';
          
          if(jobs.length>0){
            jobId=jobs[0].id
       
          }
          setSelectedId(jobId);
     
         

          const pages = Math.floor(size / itemsPerPage);
          if (Math.round(size % itemsPerPage) > 0) {
            const totalPages = pages + 1;
            setTotalPage(totalPages);
          } else {
            const totalPages = pages;
            setTotalPage(totalPages);
          }
        }
      } catch (err) {
        console.log("error" + JSON.stringify(err));
      }
    });
  };
  const FindJobs = () => {
    setFindJobs(true);
    getAlljobsList();
    // setAddress("");
    setJobId("");

  };
  const [jobId, setJobId] = useState("");
  const [id, setId] = useState("");

  const handleDescription = (job) => {
    setJobId(job.jobId);
    setId(job.id)
  };

  const JobCardActive = (job) => {

    var classnames =
      "JobCard  flex flex-row w-full relative bg-primary-white shadow-md rounded-xl border border-primary-gray2 gap-1 t-p-4 pb-6 max-lg:pt-11 ";



    if (jobId == job.jobId) {
      classnames =
        "JobCard active flex flex-row w-full relative bg-primary-white shadow-md rounded-xl border border-primary-gray2 gap-1 t-p-4 pb-6 max-lg:pt-11";
    }
   

    
    return classnames;
  };

  const showAccount = (account) => {
    if (!isNullOrEmpty(account)) {
      return account.name;
    }
  };

  const showCityState = (address) => {
    const add = [];
    if (!isNullOrEmpty(address)) {
      if (!isNullOrEmpty(address.city)) {
        add.push(address.city);
      }
      if (!isNullOrEmpty(address.state)) {
        add.push(address.state);
      }
      if (!isNullOrEmpty(address.zipcode)) {
        add.push(address.zipcode);
      }
    }
    return add.join(", ");
  };

  const checkJobSalary = (jobResponse) => {
    if (jobResponse !== null) {
      let salaryMin = jobResponse.salaryMin;
      let salaryMax = jobResponse.salaryMax;
      let salaryType = jobResponse.salaryType;

      if (salaryMin == 0 && salaryMax == 0) {
        return <></>;
      } else if (salaryMin !== 0 && salaryMax == 0) {
        return (
          <>
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)} /
            <span className="text-xs text-[#777777]">
              {showSalaryType(salaryType)}
            </span>{" "}
          </>
        );
      } else if (salaryMin == 0 && salaryMax !== 0) {
        return (
          <>
            {" "}
            {"$" + showSalary(salaryMax, salaryMin, salaryMax)} /
            <span className="text-xs text-[#777777]">
              {showSalaryType(salaryType)}
            </span>{" "}
          </>
        );
      } else if (salaryMin == salaryMax) {
        return (
          <>
            {" "}
            {"$" + showSalary(salaryMin, salaryMin, salaryMax)} /
            <span className="text-xs text-[#777777]">
              {showSalaryType(salaryType)}
            </span>{" "}
          </>
        );
      } else {
        return (
          <>
            {" "}
            {"$" +
              showSalary(salaryMin, salaryMin, salaryMax) +
              "-" +
              "$" +
              showSalary(salaryMax, salaryMin, salaryMax)}{" "}
            /
            <span className="text-xs text-[#777777]">
              {showSalaryType(salaryType)}
            </span>{" "}
          </>
        );
      }
    }
  };
  const showSalaryType = (salaryType) => {
    if (salaryType !== null) {
      if (salaryType != null) {
        if (salaryType.key === "HOURLY") {
          return "hour";
        } else if (salaryType.key === "ANNUAL") {
          return "year";
        } else if (salaryType.key === "MONTHLY") {
          return "month";
        }
        return salaryType.value;
      }
    }
  };

  const onChangePage = (e) => {
    setCurrentPage(e);
  };

  const JobDescription = (jobDescription) => {
    if (jobDescription.length > 150) {
      return jobDescription.substring(0, 150) + "...";
    } else {
      return jobDescription;
    }
  };
  const getJobBenefits = (jobBenefits) => {
    const bList = [];
    const maxBenefitsToShow = 6;
    let count = 0;
    const benefitsArray = [
      { key: "cobra", label: "Cobra" },
      { key: "Disability", label: "Disability" },
      { key: "medicalLeave", label: "MedicalLeave" },
      { key: "minimumWage", label: "MinimumWage" },
      { key: "overtime", label: "Overtime" },
      { key: "unEmploymentBenefit", label: "UnEmploymentBenefit" },
      { key: "WorkerCompensation", label: "WorkerCompensation" },
      { key: "bonusPay", label: "BonusPay" },
      { key: "compensation401k", label: "401k" },
      { key: "stockOption", label: "StockOption" },
      { key: "health", label: "Health" },
      { key: "dental", label: "Dental" },
      { key: "vision", label: "Vision" },
      { key: "lifeInsurance", label: "Life Insurance" },
      { key: "paidHoliday", label: "Paid Holidays" },
      { key: "paidSickTime", label: "Paid SickTime" },
      { key: "paidVacation", label: "Paid Vacation" },
      { key: "flexibleHour", label: "Flexible Hour" },
      { key: "parentalLeave", label: "Parental Leave" },
      { key: "tuition", label: "Tuition" },
      {
        key: "profDeveAssistance",
        label: "Professional Development Assistance ",
      },
      { key: "empDiscount", label: "Employee Discounts" },
    ];

    for (const benefit of benefitsArray) {
      if (!isNullOrEmpty(jobBenefits)) {
        if (jobBenefits[benefit.key] && count < maxBenefitsToShow) {
          bList.push(
            <span
              key={benefit.key}
              className="inline-block mb-1 bg-Gray-200 font-semibold bg-primary-lightblue text-sm rounded-[4px] mr-[0px] px-2 pt-[2px] pb-[4px]"
            >
              {benefit.label}
            </span>
          );
          count++;
        }
      }
    }
    return <div>{bList}</div>;
  };

  const getTotalSelectedBenefits = (jobBenefits) => {
    var add = [];

    if (!isNullOrEmpty(jobBenefits)) {
      if (jobBenefits.cobra) {
        add.push("Cobra");
      }
      if (jobBenefits.Disability) {
        add.push("Disability");
      }
      if (jobBenefits.medicalLeave) {
        add.push("MedicalLeave");
      }
      if (jobBenefits.minimumWage) {
        add.push("MinimumWage");
      }
      if (jobBenefits.overtime) {
        add.push("overtime");
      }
      if (jobBenefits.unEmploymentBenefit) {
        add.push("UnEmploymentBenefit");
      }
      if (jobBenefits.WorkerCompensation) {
        add.push("WorkerCompensation");
      }
      if (jobBenefits.bonusPay) {
        add.push("BonusPay");
      }
      if (jobBenefits.compensation401k) {
        add.push("401k");
      }
      if (jobBenefits.stockOption) {
        add.push("StockOption");
      }
      if (jobBenefits.health) {
        add.push("Health");
      }
      if (jobBenefits.dental) {
        add.push("Dental");
      }
      if (jobBenefits.vision) {
        add.push("Vision");
      }
      if (jobBenefits.lifeInsurance) {
        add.push("Life Insurance");
      }
      if (jobBenefits.paidHoliday) {
        add.push("Paid Holidays");
      }
      if (jobBenefits.paidSickTime) {
        add.push("Paid Holidays");
      }
      if (jobBenefits.paidVacation) {
        add.push("Paid Vacation");
      }
      if (jobBenefits.flexibleHour) {
        add.push("Flexible Hour");
      }
      if (jobBenefits.parentalLeave) {
        add.push("Parental Leave");
      }
      if (jobBenefits.tuition) {
        add.push("Tuition");
      }
      if (jobBenefits.profDeveAssistance) {
        add.push("Professional Development Assistance");
      }
      if (jobBenefits.empDiscount) {
        add.push("Employee Discounts");
      }
      return add.join(", ");
    }
  };

  const getJobEnum = () => {
    getAllEnumLists().then((response) => {
      if (!isNullOrEmpty(response.data)) {
        var filters = response.data;
        var salaryTypes = filters.salaryTypes;

        if (!isNullOrEmpty(salaryTypes)) {
          setSalaryType(salaryTypes);
        }
        var jobType = filters.jobTypes;
        if (!isNullOrEmpty(jobType)) {
          setJobType(jobType);
        }
        var workStatues = filters.workStatues;
        if (!isNullOrEmpty(workStatues)) {
          setWorkStatus(workStatues);
        }
      }

      // setSalaryType(salaryType.key)
    });
  };

  const handleSalaryType = (e) => {
    setSelectedSalaryType(e.target.value);

    const selectedPosition = e.target.selectedIndex;
    if (selectedPosition == 0) {
      setJobSalaryType("");
    } else {
      if (salaryType.length > 0) {
        let type = salaryType[selectedPosition].key;
        setJobSalaryType(type);
      }
    }
  };

  const handleJobType = (e) => {
    setSelectedJobType(e.target.value);
    const selectedPosition = e.target.selectedIndex;
    if (selectedPosition == 0) {
      setJobstype("");
    } else {
      if (jobType.length > 0) {
        let type = jobType[selectedPosition - 1].key;
        setJobstype(type);
      }
    }
  };

  const handleWorkStatus = (e) => {
    setSelectedWorkStatus(e.target.value);
    const selectedPosition = e.target.selectedIndex;
    if (selectedPosition == 0) {
      setJobWorkStatus("");
    } else {
      if (workStatus.length > 0) {
        let type = workStatus[selectedPosition - 1].key;
        setJobWorkStatus(type);
      }
    }
  };
  const handleModal =(close)=>{

    setModalLong(!close)
  }

  

  const showImage = (account) => {
    if (!isNullOrEmpty(account)) {
      if (!isNullOrEmpty(account.logo)) {
        return account.logo;
      } else {
        return orgImage;
      }
    } else {
      return orgImage;
    }
  };

  const capitalizeFirst = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <>
      <div className="AllJobsWrapper flex flex-col gap-2 max-md:col-span-6 min-md:col-span-6 ">
        <div className="FindJobsTitle">
          <h1 className="t-alljobs-headings text-2xl font-bold  w-full t-search-input-field">
            Search Jobs
          </h1>
        </div>
       
        <div className="   max-md:flex-col ">
          <div className=" basis-5/6">
            {/* <div className="JobsSearch p-1 border border-primary-gray2 w-full rounded-lg px-2" > */}


            <div class="filterlist">
<ul>
  <li className="width"><Input
                  type="text"
                  className="t-rounded-lg form-control"
                  placeholder=" Search Title"
                  onChange={(e) => setSearch(e.target.value)}
                /></li>
  <li className="width">                <SearchPlaceComponent parentCallback={handleCallback} />

</li>
  <li>   <Input
                      id="billingRate"
                      placeholder="Within 60 miles"
                      className="t-rounded-lg"
                      type="select"
                      value={distance}
                      onChange={(e) => setDistance(e.target.value)}
                    >
                      <option value="">Please Select Miles</option>
                      <option value="1">Within 1 mile </option>
                      <option value="2">Within 2 miles</option>
                      <option value="5">Within 5 miles</option>
                      <option value="10">Within 10 miles</option>
                      <option value="20">Within 20 miles</option>
                      <option value="25">Within 25 miles</option>
                      <option value="30">Within 30 miles</option>
                      <option value="40">Within 40 miles</option>
                      <option value="50">Within 50 miles</option>
                      <option value="75">Within 75 miles</option>
                      <option value="100">Within 100 miles</option>
                    </Input></li>

<li>
<InputGroup>
              <Input
                type="number"
                placeholder="Minimun Salary"
                className="t-input-group-left-radius"
                onChange={(e)=>setSalaryMin(e.target.value)}
                value={salaryMin}
              />
              
              <InputGroupAddon>
                <Input
                  type="select"
                  className="t-salaryestimation-filter t-input-group-right-radius"
                  value={selectedSalaryType}
                  id="prefContactTime"
                  onChange={handleSalaryType}
                >
                  {salaryType.length > 0 &&
                    salaryType.map((type) => (
                      <option value={type.value} key={type.key}>
                        {type.value}
                      </option>
                    ))}
                </Input>
              </InputGroupAddon>
            </InputGroup>  </li>
  <li>
  <Input
              type="select"
              className="t-rounded-lg"
              value={selectedJobType}
              id="prefContactTime"
              onChange={handleJobType}
            >
              <option value="">Any Job Types</option>
              {jobType.length > 0 &&
                jobType.map((type) => (
                  <option value={type.value} key={type.key}>
                    {type.value}
                  </option>
                ))}
            </Input>    </li>
  <li>
  <Input
              type="select"
              className="t-rounded-lg"
              value={selectedWorkStatus}
              id="prefContactTime"
              onChange={handleWorkStatus}
            >
              <option value="">Any Job Models</option>
              {workStatus.length > 0 &&
                workStatus.map((type) => (
                  <option value={type.value} key={type.key}>
                    {type.value}
                  </option>
                ))}
            </Input>    </li>
    
  <li>
  <Input
              type="select"
              className="t-rounded-lg"
              value={postedOn}
              id="prefContactTime"
              onChange={(e)=>setPostedOn(e.target.value)}
            >
              <option value="">Date Posted</option>
              <option value="1">Last 24 hours</option>
              <option value="3">Last 3 days</option>
              <option value="7">Last 7 days</option>
              <option value="14">Last 14 days</option>
            </Input>    </li>
  </ul>
</div>


           

            {/* </div> */}
            {/* <div className="JobsFilters p-1 border border-primary-gray2 w-full rounded-lg px-2"> */}
            {/* <Input
              type="text"
              className=""
              placeholder="Job Filters Go here"
              onChange={(e) => setLocation(e.target.value)}
            ></Input> */}
          </div>
          {/* </div> */}
        </div>
        {/* {size} */}

        {/* <Row>
          <Colxx sm={3} className="t-search-input-field">
            <InputGroup>
              <Input
                type="number"
                placeholder="Minimun Salary"
                className="t-input-group-left-radius"
                onChange={(e)=>setSalaryMin(e.target.value)}
                value={salaryMin}
              />
              
              <InputGroupAddon>
                <Input
                  type="select"
                  className="t-salaryestimation-filter t-input-group-right-radius"
                  value={selectedSalaryType}
                  id="prefContactTime"
                  onChange={handleSalaryType}
                >
                  {salaryType.length > 0 &&
                    salaryType.map((type) => (
                      <option value={type.value} key={type.key}>
                        {type.value}
                      </option>
                    ))}
                </Input>
              </InputGroupAddon>
            </InputGroup>
          </Colxx>
          <Colxx sm={3} className="t-search-input-field">
            <Input
              type="select"
              className="t-rounded-lg"
              value={selectedJobType}
              id="prefContactTime"
              onChange={handleJobType}
            >
              <option value="">Any Job Types</option>
              {jobType.length > 0 &&
                jobType.map((type) => (
                  <option value={type.value} key={type.key}>
                    {type.value}
                  </option>
                ))}
            </Input>
          </Colxx>
          <Colxx sm={3} className="t-search-input-field">
            <Input
              type="select"
              className="t-rounded-lg"
              value={selectedWorkStatus}
              id="prefContactTime"
              onChange={handleWorkStatus}
            >
              <option value="">Any Job Models</option>
              {workStatus.length > 0 &&
                workStatus.map((type) => (
                  <option value={type.value} key={type.key}>
                    {type.value}
                  </option>
                ))}
            </Input>
          </Colxx>
          <Colxx sm={3} className="t-search-input-field">
            <Input
              type="select"
              className="t-rounded-lg"
              value={postedOn}
              id="prefContactTime"
              onChange={(e)=>setPostedOn(e.target.value)}
            >
              <option value="">Date Posted</option>
              <option value="1">Last 24 hours</option>
              <option value="3">Last 3 days</option>
              <option value="7">Last 7 days</option>
              <option value="14">Last 14 days</option>
            </Input>
          </Colxx>
        </Row> */}

        <div className="FindJobsButton basis-1/6 t-search-input-field">
          <TeamanicsButtonStyle
            className="max-md:w-full"
            onClick={FindJobs}
          >
            Find Jobs
          </TeamanicsButtonStyle>
        </div>
        <hr />
        <div className="JobsContainer">
          <h2 className="JobsHeader text-dark text-lg font-bold t-search-input-field">
            Available Jobs
          </h2>

          <div className="JobsWrapper grid min-lg:grid-cols-5 gap-2">
            <div
              className="JobsList min-lg:col-span-2 flex flex-col gap-5 max-lg:gap-7 min-lg:min-h-[30vh]
              min-lg:max-h-[70vh] overflow-y-scroll hover:scrollbar-thin scrollbar-none
                            py-3 pl-1 min-lg:pr-8 max-lg:pr-3 max-lg:-mr-3
                            min-lg:border-r-[1px]"
            >
              
              {responseList.length > 0 &&
                responseList.map((job, index) => {
                  {
                    return (
                      <div
                        key={index}
                        // className={`${JobCardActive(job)}`}
                        className={`JobCard ${JobCardActive(
                          job
                        )} flex flex-row w-full relative
                          bg-primary-white shadow-md rounded-xl border border-primary-gray2
                          gap-1 t-p-4 pb-6 max-lg:pt-11`}
                      >
                        {/* <div
                          id="nav-toggle"
                          className="group cursor-pointer 
                                                      max-md:drop-shadow-2xl hover:drop-shadow-sm transition-all ease-in-out z-40 
                                                      absolute top-0 max-md:top-2 right-0"
                        >
                          <div className="myjob_options absolute right-10 min-md:top-4 min-xl:top-7 z-40 max-lg:right-4 max-lg:top-2">
                            <span className="bg-primary-dark block w-1 h-1 m-1 rounded-full"></span>
                            <span className="bg-primary-dark block w-1 h-1 m-1 rounded-full"></span>
                            <span className="bg-primary-dark block w-1 h-1 m-1 rounded-full"></span>
                          </div>
                          <nav className="hidden group-hover:block dropdown absolute z-30 right-[15px] min-md:top-0 min-xl:top-4 w-[170px] bg-transparent h-20 ">
                            <div className="relative max-md:absolute text-primary-dark tracking-widest font-semibold w-full text-sm z-30 shadow-lg rounded-lg transition ease-in-out">
                              <ul className="jobOptions absolute z-40 flex flex-col rounded-lg gap-1 left-0 right-0 py-[12px] top-12 bg-primary-white border border-primary-gray2 shadow-xl">
                                <li className="py-[7px]  px-3 hover:text-Gray-500 menuItem">
                                  <a href="#">
                                    <svg
                                      className="w-[17px] inline align-bottom fill-[#999] css-12dcz5i eac13zx0 "
                                      xmlns="http://www.w3.org/2000/svg"
                                      focusable="false"
                                      role="presentation"
                                      viewBox="0 0 24 24"
                                      aria-hidden="true"
                                    >
                                      <path
                                        fillRule="evenodd"
                                        d="M12 14.616l6 3.905V4H6v14.52l6-3.905zM4.383 21.96A.25.25 0 014 21.748V2.502a.5.5 0 01.5-.5h15a.5.5 0 01.5.5v19.246a.25.25 0 01-.383.212L12 17.002 4.383 21.96z"
                                        clipRule="evenodd"
                                      ></path>
                                    </svg>
                                    Save Job
                                  </a>
                                </li>
                                <li className="py-[7px]  px-3 hover:text-Gray-500  menuItem">
                                  <a href="#">
                                    <svg
                                      className="w-[17px] inline align-bottom fill-[#999] "
                                      viewBox="0 0 24 24"
                                      role="presentation"
                                      aria-hidden="true"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM4 12C4 7.58 7.58 4 12 4C13.85 4 15.55 4.63 16.9 5.69L5.69 16.9C4.63 15.55 4 13.85 4 12ZM12 20C10.15 20 8.45 19.37 7.1 18.31L18.31 7.1C19.37 8.45 20 10.15 20 12C20 16.42 16.42 20 12 20Z"></path>
                                    </svg>
                                    Not Interested
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </nav>
                        </div> */}
                        <span onClick={(e) => handleDescription(job)}>
                          <a>
                            <div className="MyJobDetails relative flex flex-col gap-3">
                              <div
                                className="JobType absolute min-lg:-bottom-7 min-lg:right-0
                                              max-lg:-top-11 max-lg:left-0 
                                              bg-primary-blue
                                              px-5 pb-2 text-sm font-bold text-primary-white
                                              max-lg:rounded-br-xl max-lg:rounded-bl-xl max-lg:rounded-tl-sm max-lg:rounded-tr-sm
                                              min-lg:rounded-br-sm min-lg:rounded-bl-sm min-lg:rounded-tl-xl min-lg:rounded-tr-xl
                                  "
                              >
                                <span className="mr-2 inline">
                                  <svg
                                    className="w-[14px] mr-1 inline align-middle fill-[#FFF] "
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                  >
                                    <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
                                  </svg>
                                  {job.jobType.value}{" "}
                                </span>
                                <span className="text-[#7cc4ff] text-2xl leading-none font-light">
                                  |
                                </span>
                                <span className="ml-2 inline">
                                  <svg
                                    className="w-[14px] inline align-middle fill-[#FFF] "
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 512 512"
                                  >
                                    <path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464H398.7c-8.9-63.3-63.3-112-129-112H178.3c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3z" />
                                  </svg>
                                  {job.workStatus.value}{" "}
                                </span>
                              </div>
                              <div className="MyJob_info col-span-2 flex flex-row gap-3 ">
                                <div>
                                  <div
                                    className="myjob_company h-[64px] w-[64px] 
                                              items-center border-primary-gray2 border rounded-lg bg-white shadow-4xl 
                                              p-1 max-w-[64px]
                                              flex top-0 left-0 z-50 t-suggestion-img-height"
                                  >
                                    <img
                                      className="w-full h-auto"
                                      src={showImage(job.account)}
                                      // src={!isNullOrEmpty(job.account) ? job.account.logo : orgImage }
                                      alt="Company"
                                    />
                                  </div>
                                </div>

                                <div className="JobTitleDetails">
                                  {job.publicTitle ? (
                                    <div>
                                      <p className="JobTitle text-lg font-bold text-primary-blue inline-block mb-0">
                                        <strong>
                                          {capitalizeFirst(job.publicTitle)}
                                        </strong>
                                      </p>
                                    </div>
                                  ) : (
                                    <></>
                                  )}
                                  <p className="JobEmployer text-primary-dark font-semibold text-sm mb-0">
                                    {showAccount(job.account)}
                                  </p>
                                  <p className="JobLocation text-Gray-600 font-normal text-sm mb-0">
                                    {showCityState(job.address)}
                                  </p>
                                </div>
                              </div>
                              <div className="Job_details relative">
                                <div className="Job_pay text-[16px] text-[#333333] font-bold text-center inline-block pb-4">
                                  <span className="text-lg text-[#333333]">
                                    {/* $60,000 - $80,000 / */}
                                    {checkJobSalary(job)}
                                  </span>
                                </div>

                                <div
                                  className="Job_pointers block t-benefits-container"
                                  title={getTotalSelectedBenefits(
                                    job.benefits
                                  )}
                                >
                                  <span>{getJobBenefits(job.benefits)}</span>
                                </div>
                                <div className="text-sm text-[#444] font-[400]">
                                  <ul >
                                    <li>
                                      <div
                                        
                                        style={{ textOverflow: "clip" }}
                                      >
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: JobDescription(
                                              job.jobDescription
                                            ),
                                          }}
                                        />
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                <div className="datePosted text-xs text-[#999]">
                                  <svg
                                    className="w-[14px] inline align-top fill-[#999] mr-1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 448 512"
                                  >
                                    <path d="M148 288h-40c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm108-12v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 96v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm-96 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm192 0v-40c0-6.6-5.4-12-12-12h-40c-6.6 0-12 5.4-12 12v40c0 6.6 5.4 12 12 12h40c6.6 0 12-5.4 12-12zm96-260v352c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V112c0-26.5 21.5-48 48-48h48V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h128V12c0-6.6 5.4-12 12-12h40c6.6 0 12 5.4 12 12v52h48c26.5 0 48 21.5 48 48zm-48 346V160H48v298c0 3.3 2.7 6 6 6h340c3.3 0 6-2.7 6-6z" />
                                  </svg>
                                  Posted <span>{dayDifference(job.createdOn)}</span>
                                </div>

                                <button
                                  className="viewJob_button bg-primary-blue rounded-md text-center text-sm 
                                                      text-primary-lightblue font-semibold 
                                                      p-2 inline-block mt-4 py-[8px] px-[15px] "onClick={() => setModalLong(!ModalLong)}
                                >
                                  View Job Details
                                </button>
                              </div>
                            </div>
                          </a>
                        </span>
                      </div>
                    );
                  }
                })}
            </div>


{!isNullOrEmpty(selectedId) &&  <AllJobsDescription id={id} selectedId={selectedId} jobId={jobId}  ModalLong={ModalLong}  responseList={responseList} parentCallback={handleModal}/>}

           
          </div>
        </div>
      </div>
    </>
  );
};

export default AllJobs;
